import { render, staticRenderFns } from "./KubeRelation.vue?vue&type=template&id=9cbedee4&scoped=true&"
import script from "./KubeRelation.vue?vue&type=script&lang=js&"
export * from "./KubeRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbedee4",
  null
  
)

export default component.exports